(function () {
	"use strict";

	var addCssRule = function(selector, rule) {
		if (document.styleSheets) {
			if (!document.styleSheets.length) {
				var head = document.getElementsByTagName('head')[0];
				head.appendChild(document.createElement('style'));
			}

			var i = document.styleSheets.length-1;
			var ss = document.styleSheets[i];

			var l=0;
			if (ss.cssRules) {
				l = ss.cssRules.length;
			} else if (ss.rules) {
		  		// IE
		  		l = ss.rules.length;
			}

			if (ss.insertRule) {
				ss.insertRule(selector + ' {' + rule + '}', l);
			} else if (ss.addRule) {
			  	// IE
				ss.addRule(selector, rule, l);
			}
		}
	};

	$('.open-profile-menu').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		var $merchantMenu = $('.dropdown-menu');
		if (!$merchantMenu.hasClass('hidden')) {
			$merchantMenu.addClass('hidden');
		}
		$('.profile-menu').toggleClass('hidden');
		$('.open-profile-menu').toggleClass('open');
	});
	$('.open-merchant-menu').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();

		$('.profile-flyout').addClass('hidden');
		$('.open-profile-menu').removeClass('open');
		$('.profile-close').removeClass('open');
		$('.multi-campus-menu').removeClass('pp-shown');
		$('.open-menu').removeClass('open');

		var $profileMenu = $('.profile-menu');
		if (!$profileMenu.hasClass('hidden')) {
			$profileMenu.addClass('hidden');
		}
		$('.merchant-menu, .merchant .dropdown-menu').toggleClass('hidden');

		var PADDING = 8;
		var $down = $('.open-merchant-menu .icon-down');
		if ($down.length > 0) {
			var pos = $down.position();
			var containerPos = $('.merchant-menu, .merchant .dropdown-menu').position();
			var left = pos.left - containerPos.left + PADDING;
			addCssRule('.arrow_merchant:after, .arrow_merchant:before', 'left:' + left + 'px;');
		}
	});

	setTimeout(function() { $("body").removeClass("no-transitions"); }, 100);
	$(document).click(function(e) {
		var menus = $('.merchant-menu, .merchant .dropdown-menu');
		menus.each(function () {
			var $this = $(this);
			if (!$this.hasClass('hidden')) {
				$this.toggleClass('hidden');
			}
		});

		if (!($('.profile-flyout').is(e.target) || $('.profile-flyout').has(e.target).length > 0)) {
			$('.profile-flyout').addClass('hidden');
			$('.open-profile-menu').removeClass('open');
			$('.profile-close').removeClass('open');
		}
	});
}());
